/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Faq_3_QInputs */

const en_vc_faq_3_q = /** @type {(inputs: Vc_Faq_3_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I use VectorCraft online without installing it?`)
};

const zh_vc_faq_3_q = /** @type {(inputs: Vc_Faq_3_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不安装能在线使用 VectorCraft 吗？`)
};

/**
* | output |
* | --- |
* | "Can I use VectorCraft online without installing it?" |
*
* @param {Vc_Faq_3_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_faq_3_q = /** @type {((inputs?: Vc_Faq_3_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Faq_3_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_faq_3_q(inputs)
	return zh_vc_faq_3_q(inputs)
});
export { vc_faq_3_q as "vc.faq.3.q" }